import { ActivatedRoute, Router } from "@angular/router";
var ActivityComponent = (function () {
    function ActivityComponent(route, router) {
        this.route = route;
        this.router = router;
    }
    ActivityComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            _this.practiceMetaId = params['practiceMetaId'];
        });
        this.page = "introduction";
    };
    ActivityComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        /*var htmlFontSize=html.clientWidth/7.5;*/
        var htmlFontSize;
        if (window.screen.width < window.screen.height) {
            htmlFontSize = window.screen.width / 7.5;
        }
        else {
            htmlFontSize = window.screen.height / 7.5;
        }
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "#2c2c50";
    };
    ActivityComponent.prototype.onSuccess = function () {
        this.page = "success";
    };
    ActivityComponent.prototype.onApply = function () {
        if (this.practiceMetaId > 0) {
            var link = [this.practiceMetaId, 'case-practice'];
            this.router.navigate(link);
        }
        else {
            this.page = "form";
        }
    };
    return ActivityComponent;
}());
export { ActivityComponent };



// WEBPACK FOOTER //
// ./src/app/activity.component.ts.pre-build-optimizer.js